import React, { useState, useEffect } from 'react';
import ReactModal from 'react-modal';
import saveIcon from '../../assets/images/save.png';
import { useSystemError } from '../../components/Error/SystemErrorContext';
import styles from '../../css/search/search-save.module.css';
import { handleError, mapResponseErrorToSystemError, mapUnknownErrorToSystemError } from '../../utils/errorUtils';


interface SaveModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onSave: (searchName: string) => void;
  initialSearchName: string;
  isEditMode: boolean;
}


const SaveModal: React.FC<SaveModalProps> = ({ isOpen, onRequestClose, onSave, initialSearchName, isEditMode }) => {
  const [searchName, setSearchName] = useState(initialSearchName);
  const [searchNameError, setSearchNameError] = useState<string | null>(null);
  const [didErrorOccur, setDidErrorOccur] = useState(false);
  const { triggerSystemError } = useSystemError();


  useEffect(() => {
    try {
      if (isOpen) {
        setSearchName(initialSearchName);
        setSearchNameError(null);
      }
    } catch (error) {
      handleError(mapUnknownErrorToSystemError(error, false), null, setDidErrorOccur, triggerSystemError);
    }
  }, [initialSearchName, isOpen]);

  useEffect(() => {
    try {
      if (!isOpen) {
        setSearchName('');
        setSearchNameError(null);
      }
    } catch (error) {
      handleError(mapUnknownErrorToSystemError(error, false), null, setDidErrorOccur, triggerSystemError);
    }
  }, [isOpen]);


  const handleSave = () => {
    try {
      if (!searchName.trim()) {
        setSearchNameError('Search name is required.');
        return;
      }
      setSearchNameError(null);
      onSave(searchName);
    } catch (error) {
      handleError(mapUnknownErrorToSystemError(error, false), null, setDidErrorOccur, triggerSystemError);
    }
  };


  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Save Search"
      className={styles.modal}
      overlayClassName={styles.overlay}
    >
      <div className={styles.modalContent}>
        <div className={styles.headerContainer}>
          <img src={saveIcon} alt="Save" className={styles.icon} />
          <h2 className={styles.header}>{isEditMode ? 'Edit Search' : 'Save Search'}</h2>
        </div>
        <p className={styles.text}>Please enter a search name:</p>
        <input
          type="text"
          value={searchName}
          onChange={(e) => {
            setSearchName(e.target.value);
            setSearchNameError(null); // Clear error as user types
          }}
          placeholder="Enter search name"
          className={styles.input}
        />
        {searchNameError && <p className={styles.errorText}>{searchNameError}</p>}
        <div className={styles.buttonContainer}>
          <button onClick={handleSave} className={styles.saveButton}>Save</button>
          <button onClick={onRequestClose} className={styles.cancelButton}>Cancel</button>
        </div>
      </div>
    </ReactModal>
  );
};


export default SaveModal;
